export default class Event {
  constructor(id, name, description, color, isDefault, isDrawable) {
    this._id = id;
    this._name = name;
    this._description = description;
    this._color = color;
    this._isDefault = isDefault;
    this._isDrawable = isDrawable;
  }

  setIsDrawable(isDrawable) {
    this._isDrawable = isDrawable;
  }

  getId() {
    return this._id;
  }

  getName() {
    return this._name;
  }

  getDescription() {
    return this._description;
  }

  getColor() {
    return this._color;
  }

  getIsDefault() {
    return this._isDefault;
  }

  getIsEditable() {
    return !this._isDefault || (this._id >= 45000 && this._id < 46000);
  }

  getIsDrawable() {
    return this._isDrawable;
  }
}

module.exports = Event;
